const MY_FLEET = {
  pageTitle: 'Minha Frota',
  myFleetSubpages: {
    table: {
      name: 'Nome',
      finishedDeliveries: 'Entregas realizadas',
      workedDays: 'Dias trabalhados',
      cancelledOrders: 'Pedidos cancelados',
      totalPayment: 'Total a pagar',
      buttonMore: 'Mostrar mais',
      tooltip: {
        workedDays: {
          title: 'Dias trabalhados',
          text: 'Consideramos um dia trabalhado quando a pessoa entregadora realizou pelo menos uma entrega no período de 24 horas do dia.',
        },
        totalPayment: {
          title: 'Total a pagar',
          text: 'Este é o valor calculado com base no "modelo de pagamento" conectado a pessoa entregadora.',
          tipText:
            'Lembre-se: o valor corresponde ao período que você selecionou.',
        },
      },
      noPaymentModelMobile: 'Nenhum modelo vinculado',
    },
    generalReport: {
      title: 'Relatório Geral',
    },
    manageCouriers: {
      searchFilter: 'Filtro de Busca',
      placeholderText: 'Procurar pessoa pelo nome',
      newPerson: 'Adicionar nova',
      infoContent: {
        detailsTitle: 'Dados Pessoais',
        name: 'Nome Completo:',
        document: 'CPF:',
        email: 'Email:',
        phone: 'Telefone:',
      },
      paymentModelContent: {
        paymentModelAssociated: 'Modelo de pagamento vinculado:',
        amountPerDelivery: 'Valor pago por entrega',
        amountPerDay: 'Valor pago por diária',
        amountPerCancellation: 'Valor pago por pedidos cancelados',
        mobile: {
          paymentModelTitle: 'Detalhes do modelo associado:',
          date: {
            from: 'De',
            until: 'à',
          },
        },
      },
      paymentInfoTitle: 'Pagamento',
      courierNotFound: {
        title: 'Nenhum resultado encontrado',
        text: 'Clique ao lado do filtro para adicionar essa \n pessoa a sua loja.',
        buttonTitle: 'Remover filtro',
      },
      noPaymentModel: 'Conecte a um modelo',
    },
  },
}

export default MY_FLEET
